export class AccountStructure {

  public NomeRepresentante: string = '';
  public NomeCTC: string = '';
  public NomeGC: string = '';
  public NomeDC: string = '';
  public CodigoCTC: string = '';

  sortCriteria() {

    if (this.NomeRepresentante == '') {
      return 'ZZZZZZZZZZZZZZZZZ_'+this.NomeCTC;
    }
    else
    {
      return this.NomeRepresentante+'_'+this.NomeCTC;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/models/account-structure.ts